import { Field } from "formik";
import { flatMap, range } from "lodash";
import * as dateFns from "date-fns";

import { FormFieldWrapper } from "../../../../organisms/form-field-wrapper";
import { FormikFormInputSelect } from "../../form-input-select";

const timeOptions = flatMap(
  range(24).map(hours => {
    return range(0, 55, 5).map(minutes => {
      const time = dateFns.add(dateFns.startOfDay(new Date()), { hours, minutes });
      return {
        value: dateFns.format(time, "HH:mm"),
        label: dateFns.format(time, "p"),
      };
    });
  }),
);

interface IProps {
  id?: string;
  label?: string;
  placeholder?: string;
  required?: boolean;
}

export const FormFieldMessageTime: React.FC<IProps> = ({
  id = "textTime",
  label = "Time to send message",
  placeholder = "Select time",
  required = true,
}) => (
  <FormFieldWrapper label={label} name={id} required={required}>
    <Field
      name={id}
      placeholder={placeholder}
      component={FormikFormInputSelect}
      options={timeOptions}
    />
  </FormFieldWrapper>
);
